import { useEffect, useState } from "react";
import { publicList } from "../admin/api";

/**
 * useContent — merge admin-added items with static data.js fallback.
 * Admin items appear first (newest), static items fill the rest.
 * IDs are de-duplicated (admin can override a static item by matching its id).
 */
export function useContent(resource, staticFallback = []) {
  const [items, setItems] = useState(staticFallback);

  useEffect(() => {
    let cancelled = false;
    publicList(resource)
      .then((data) => {
        if (cancelled) return;
        if (!Array.isArray(data) || data.length === 0) return;
        const adminIds = new Set(data.map((x) => x.id));
        const merged = [
          ...data,
          ...staticFallback.filter((x) => !adminIds.has(x.id)),
        ];
        setItems(merged);
      })
      .catch(() => {
        /* silent — keep static fallback */
      });
    return () => {
      cancelled = true;
    };
  }, [resource]);

  return items;
}
